import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface SleepDebtStepProps {
  childName?: string
  onNext: () => void
}

export function SleepDebtStep({ childName, onNext }: SleepDebtStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2 mt-6">
        <h3 className="text-lg font-medium text-center">
          Did {childName || 'your baby'} seem overtired?
        </h3>
        <div className="grid grid-cols-2 gap-3 max-w-[240px] mx-auto">
          <Button
            type="button"
            variant={form.watch("signs_of_sleep_debt") ? "default" : "outline"}
            className="w-full py-3 h-auto hover:bg-accent/50"
            onClick={() => {
              form.setValue("signs_of_sleep_debt", true)
              onNext()
            }}
          >
            Yes
          </Button>
          <Button
            type="button"
            variant={!form.watch("signs_of_sleep_debt") ? "default" : "outline"}
            className="w-full py-3 h-auto hover:bg-accent/50"
            onClick={() => {
              form.setValue("signs_of_sleep_debt", false)
              onNext()
            }}
          >
            No
          </Button>
        </div>
      </div>
    </SleepStepContainer>
  )
}